import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
// import { map, catchError, of } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
// import { UserModel } from 'src/app/shared/models/user.model';

export const userDataResolver: ResolveFn<any> = (route, state) => {
  const authService = inject(AuthService);
//   const router = inject(Router);
  return authService.getUserLogged();
  // return authService.getUserLogged().pipe(
  //   map((user: UserModel) => {
  //     return user;
  //   }),
  //   catchError(error => {
  //     return of({ error });
  //   })
  // );
};
